<script>
  import ListView from '../base/ListView.vue'

  export default {
    components: {
      ListView,
    }
  }
</script>
<template>
  <list-view store="company" add-route="CompanyCreate" edit-route="CompanyUpdate">
    <template v-slot:header="slotProps">
      <b-col md="4"><strong>{{ $t('company.name.label') }}</strong></b-col>
      <b-col md="2"><strong>{{ $t('company.invoicePattern.label') }}</strong></b-col>
      <b-col md="2"><strong>{{ $t('company.customerPattern.label') }}</strong></b-col>
      <b-col md="2"><strong>{{ $t('company.projectPattern.label') }}</strong></b-col>
    </template>
    <template v-slot:item="slotProps">
      <b-col md="4">{{ slotProps.item.name }}</b-col>
      <b-col md="2">{{ slotProps.item.invoicePattern }}</b-col>
      <b-col md="2">{{ slotProps.item.customerPattern }}</b-col>
      <b-col md="2">{{ slotProps.item.projectPattern }}</b-col>
    </template>
    <template v-slot:buttons="slotProps">
      <b-button
        :to="{name: 'CompanyAssetList', params: { company: slotProps.item['@id'] }}">
        <span>Assets</span>
      </b-button>
      <b-button
        :to="{name: 'TaxRateList', params: { company: slotProps.item['@id'] }}">
        <span>Tax rates</span>
      </b-button>
    </template>
  </list-view>
</template>

